var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"situationdisplay"},_vm._l((_vm.images),function(image){return _c('van-image',{key:image.id,attrs:{"width":"100%","fit":"cover","src":image.url}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }